module.exports = __webpack_public_path__ + "static/img/protect.661b74d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/protect.png
// module id = rMCR
// module chunks = 192